import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnPersonImageComponent } from './dn-person-image.component';

@NgModule({
  declarations: [DnPersonImageComponent],
  imports: [CommonModule],
  exports: [DnPersonImageComponent],
})
export class DnPersonImageModule {}
